import React, { useState } from 'react';
import { Platform } from 'react-native';
import { useAuth } from '../contexts/AuthContext';
import logoIcon from '../../assets/Modern-Munishiji-Icon.png';

const inputStyle = {
  width: '100%',
  padding: 10,
  borderRadius: 6,
  border: '1px solid #ccc',
  marginBottom: 10,
};

const buttonStyle = {
  padding: '10px 14px',
  borderRadius: 8,
  border: 'none',
  background: 'linear-gradient(90deg, #5B63F6 0%, #7C3AED 100%)',
  color: '#fff',
  cursor: 'pointer',
  boxShadow: '0 6px 12px rgba(92, 99, 246, 0.35)',
};

export default function AuthModal() {
  const { authOpen, closeAuthModal, signIn, signUp, signInWithGoogle, loading, message } = useAuth();
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [company, setCompany] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');

  if (!authOpen) return null;

  const onSubmit = async (e) => {
    e?.preventDefault?.();
    setError('');
    setInfo('');
    // basic validation
    const emailValid = /.+@.+\..+/.test(email);
    if (!emailValid) {
      setError('Please enter a valid email address');
      return;
    }
    if (mode === 'signup') {
      if (!name || !phone) {
        setError('Name and phone are required');
        return;
      }
      if (!password || password.length < 6) {
        setError('Password must be at least 6 characters');
        return;
      }
    }
    if (mode === 'login') {
      const res = await signIn({ email, password });
      if (!res.ok) setError(res.error);
    } else {
      const res = await signUp({ email, password, name, phone, company });
      if (!res.ok) setError(res.error);
      if (res.ok && res.requiresEmailConfirm) {
        setInfo('Check your inbox and confirm your email to finish signup. Then return here to login.');
      } else if (res.ok) {
        setInfo('Signed up successfully.');
      }
    }
  };

  const onGoogle = async () => {
    setError('');
    setInfo('');
    const res = await signInWithGoogle();
    if (!res.ok) setError(res.error);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    }}>
      <div style={{ background: '#fff', borderRadius: 20, width: 520, maxWidth: '95%', boxShadow: '0 24px 48px rgba(17,24,39,0.18)', border: '1px solid #eef2ff' }}>
        {/* Creative header strip */}
        <div style={{ background: 'linear-gradient(135deg, #5B63F6 0%, #7C3AED 50%, #00C2FF 100%)', borderTopLeftRadius: 20, borderTopRightRadius: 20, padding: 18, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <img src={logoIcon} alt="Logo" style={{ width: 30, height: 30, borderRadius: 8, boxShadow: '0 6px 12px rgba(0,0,0,0.25)' }} />
            <div>
              <div style={{ fontSize: 16, fontWeight: 700 }}>{mode === 'login' ? 'Welcome back' : 'Create Account'}</div>
              <div style={{ fontSize: 12, opacity: 0.9 }}>Modern Munshiji — secure access to your dashboard</div>
            </div>
          </div>
          <button onClick={closeAuthModal} style={{ border: 'none', background: 'transparent', fontSize: 22, cursor: 'pointer', color: '#fff' }}>×</button>
        </div>
        <div style={{ padding: 24 }}>
          {/* Google button */}
          <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
            <button type="button" onClick={onGoogle} style={{ ...buttonStyle, background: '#fff', color: '#111827', boxShadow: '0 6px 12px rgba(0,0,0,0.06)', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', gap: 8 }}>
              <img alt="G" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" style={{ width: 18, height: 18 }} />
              Continue with Google
            </button>
            <div style={{ alignSelf: 'center', color: '#64748b', fontSize: 12 }}>
              or use email
            </div>
          </div>
        <form onSubmit={onSubmit}>
          {mode === 'signup' && (
            <>
              <input style={inputStyle} placeholder="Full Name" value={name} onChange={(e) => setName(e.target.value)} />
              <input style={inputStyle} placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
              <input style={inputStyle} placeholder="Company (optional)" value={company} onChange={(e) => setCompany(e.target.value)} />
            </>
          )}
          <input style={inputStyle} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input style={inputStyle} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          {error ? <div style={{ color: 'crimson', marginBottom: 10 }}>{error}</div> : null}
          {(message || info) ? <div style={{ color: '#0f766e', background: '#ecfeff', border: '1px solid #cffafe', borderRadius: 6, padding: 8, marginBottom: 10 }}>{info || message}</div> : null}
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <button type="submit" style={buttonStyle} disabled={loading}>
              {loading ? 'Please wait…' : (mode === 'login' ? 'Login' : 'Create Account')}
            </button>
            <button type="button" style={{ ...buttonStyle, background: '#e5e7eb', color: '#111827', boxShadow: 'none' }} onClick={() => setMode(mode === 'login' ? 'signup' : 'login')}>
              {mode === 'login' ? 'Sign up' : 'Have an account? Login'}
            </button>
          </div>
          {mode === 'signup' && (
            <p style={{ fontSize: 12, color: '#64748b', marginTop: 8 }}>
              By creating an account, you agree to confirm your email. You’ll be able to save invoices to your dashboard once verified.
            </p>
          )}
        </form>
        </div>
      </div>
    </div>
  );
}